import database from './indexedDb'
import { driver, names, userDriver } from './localStorage'

const localStorage = {
  Driver: driver,
  Names: names,
  UserDriver: userDriver,
}

export { database, localStorage }
